import React from 'react';
import { KaziPeopleIcon } from '@/features/shared/components/branding/KaziPeopleLogo';

// Matches the inline splash in index.html so the hand-off from the pre-JS HTML
// splash to React (PersistGate rehydration) is seamless — no blank/flash.
// The `am-spin` keyframes are defined in index.html's <head>, so they're global.
export const Splash: React.FC = () => (
  <div
    style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: '#FBF6F1',
      fontFamily: '"Plus Jakarta Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    }}
  >
    <div style={{ textAlign: 'center' }}>
      <KaziPeopleIcon
        size={60}
        style={{ margin: '0 auto 16px', boxShadow: '0 8px 20px rgba(242, 138, 58, 0.30)' }}
      />
      <div style={{ fontWeight: 800, fontSize: 22, letterSpacing: '-0.01em', color: '#2F3443', marginBottom: 22 }}>
        Kazi<span style={{ color: '#F6B26B' }}>People</span>
      </div>
      <div
        style={{
          width: 26, height: 26, margin: '0 auto',
          border: '3px solid #FDE2C9', borderTopColor: '#F28A3A', borderRadius: '50%',
          animation: 'am-spin 0.8s linear infinite',
        }}
      />
    </div>
  </div>
);

export default Splash;
